import { ConfigurationValues } from '@cutr/constants/windows/windows';
import { CONFIGURATIONS_OPTIONS } from '@cutr/constants/windows/windows-configurations.ts';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';

import { Label } from '@/windows/primitives/Label';

import { GridSelectModal } from '../../GridSelectModal';
import { unboxLabel } from '../Configurations';
import { ConfigurationComponent } from '.';

const WindowSillDecorativeProfileConfigurationInput = () => {
  const { t } = useTranslation();
  const labelId = useId();
  const inputId = useId();

  const windowSillDecorativeProfileConfigs =
    CONFIGURATIONS_OPTIONS.windowSillDecorativeProfile.options;

  const windowSillDecorativeProfileOptions =
    windowSillDecorativeProfileConfigs.map((config) => ({
      config,
      imagePath:
        config.value === 'none'
          ? '/sorpetaler/none.jpg'
          : `/sorpetaler/windowSillsDecorativeProfile/${config.value}.jpg`,
    }));

  return (
    <>
      <Label id={labelId} htmlFor={inputId}>
        {t(`windows.configurations.windowSillDecorativeProfile.label`)}
      </Label>
      <GridSelectModal
        configurationKey="windowSillDecorativeProfile"
        dispatchAction="SET_WINDOW_SILL_DECORATIVE_PROFILE"
        options={windowSillDecorativeProfileOptions}
        buttonId={inputId}
      />
    </>
  );
};

const config: ConfigurationComponent<'windowSillDecorativeProfile'> = {
  key: 'windowSillDecorativeProfile',
  input: <WindowSillDecorativeProfileConfigurationInput />,
  display: (value: ConfigurationValues['windowSillDecorativeProfile']) => (
    <span>{unboxLabel(value?.label)}</span>
  ),
};

export default config;
